import type { Interpolation, Theme as ReactTheme } from "@emotion/react";
import { useTheme } from "@mui/material";
import Zoom from "@mui/material/Zoom";

interface CountBadgeProp {
  countNotification: string | number;
}

export function CountBadge({ countNotification }: Readonly<CountBadgeProp>) {
  const theme = useTheme();
  const notificationStatusCss: Interpolation<ReactTheme> = {
    position: "absolute",
    top: 8,
    right: 5,
    background: theme.palette.error.main,
    boxShadow: "0px 4px 6px rgba(255, 20, 115, 0.2)",
    color: "white",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 10,
    paddingLeft: 4,
    paddingRight: 4,
    // width: 16,
    minWidth: 16,
    height: 16,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Zoom in={Boolean(countNotification)}>
      <div className="notification-status" css={notificationStatusCss} children={countNotification} />
    </Zoom>
  );
}
